import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from "react";
import MK from 'src/components/MK';

export default function Test(props) {

  return (
    <div style={{ padding: 50 }}>
      <MK.Entity field='consultor' entity='Cliente' label='Consultor' change={(args) => {
        console.log(args)
      }} />
      <MK.Grid list={{ url: 'Cliente' }} field='clientes'>
        <MK.Column field='id' label='Codigo' />
        <MK.Column field='codigo' label='CM' />
      </MK.Grid>
    </div>
  );
}